var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTubeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3758_55802",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.469971,
    width: 27.7273,
    height: 20,
    fill: "url(#pattern0_3758_55802)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3758_55802)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 28,
    height: 20,
    fill: "#1D5AE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3758_55802",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3758_55802",
    transform: "scale(0.00819672 0.0113636)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3758_55802",
    width: 122,
    height: 88,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAABYCAYAAAA6PePZAAAAAXNSR0IArs4c6QAABURJREFUeF7tnf1ZFDEQxjMViBWIFagVCBUoFagViBWIHWgFQgVABUoHUIHSwVFB3HfJntnc7mU32Tvy8eZ5+IfbZCfz23zMZJKIyiBprY8CxDxQSr2eke/3jGe7R1cichuQb+9ZZMk3DgCBoqFwOw1BwzOvlpQlkbLulFKrAVncjwrPuB/MrYgM5Q2qWjBorfV7pRSg4a9ESEEK3UGme/MR4OO4EpG/Ie+YBVprfdh8oadKqY9KqWchL2SeaA3cNCWcicisoWYyaK31mYFMwNGsFikAwE+nzhG8oLXWGGfP2T0vAmcXhXwRke++greCNpOrK3bTPjU++e8XzdiN4XQ0jYI2k63LJ68CBZiqga2wB0Gb7hqDPcfjqWpO47kfjUmGyfJG2gCttYZNC5vuRRqyU4qZGjgREQy3vTQEGgP755mF8/F0NPDQTJ4PXWdLD7SZfP1KR2ZKEqiBbyICc3idXNAYl98GFs5saWngud2q16CN1+tPWrJSmggN9Fq1DZpjc4RWE8x6LyJwWbfJBg1nOWfaCRKLEOlN5yJtQbPbjlBl2lnX7tEONNxnP9OWmdIFaOC6adFYTn7sus3K1NeAgpglbQ3cNc6TNsqmAw1Pyru0ZaZ0IRqQxqC2QdN+DtFiBnlc0PBtMxwoA3ABIh4jGqXrunVAAcyShwYIOg9O0VJ+ahwn50IbOlqRqRfQukIBGuG6XLFKHVe4fAQdrruscrZRJ2jR8JwwNiwrdrOEvWlm3UcAjQXq3L1iL5uqox4fZqmgjofLAd05BczEksD7H3B5oLv6GeDYdMBoGaXadekiuu6uRbs9sbEo0MKrBg79AHT2fu4x0FYLhwlZLfBqQFvAYWEgZKqqSJrqQFvAEWiBFl4F8GpB1wa8etAAbrYgYb8S/krda3ZcxWRsil+kcOAEPWCSYZMhWnfu3kK7ai3o7IMOfObVlBY9ABzB76V42Qja9xEU4lYlaB9oa4aOsFnY4Dl62Qh6KujMvWwEPRe0Y4PnsruFoOeCznTMJuipoI2djTE6x+AGgvaBLsSRQtBjoAsB3FWPoLd4xkryfdMFaoMu+GBbgjYrWKWvT9cNWmtdOuC2w6p2PboWwN2wVB1oExWKMOAqQoiqA1172G/xLbp2wG6Lzn7vlRt4QMA978BDcxXDQVE7NcyCA/zRPGHpP+ty9l4ppbibctxpXxRo39pEzb+vQfNoi7I/g/aYSJ5hUjZk1I5nmJTPuK3hGjTil3nyfrnUH0Gb1Zvsg/jL5RRdM54cGK3CPArogeahr3lAC5GyBzr74y1CNFBDHvcYZx7MXih1F3T2CxuFcoqt1sZVC7w8JValaebfuDyFtnSaoGKl6l+HZGxpXnAWq9b08vcvODOgeWVheqBiJBq9spDdd4xa08s7fAmpadW0p9MDFirR8LXCBjTXpkPVmla+7ReFc6xOi1agNA9KqUP7knCU07sR3oDGOVvwfVcV5B6o1BSznTT3UcLT2UsboA1snMCD8brUIxNTBLSETBtddlfoIGgDm5eqLKH6/ZVxISLwcA6mUdDW5AzdAFv2/oCFvGkr5MEx2n2L1hrdODam8ZLSEAS7zYOJ1ymuJPS9ZmuLtjMXfBqAT0ep/n5tIMN17U2TQZuuHN4znO2BsYDduVe9O3ngAj0srgqeU/os0E4Lx2QNDhZ07TmejzlHT0/57J0xdwH2yrWPpwoWDHroBebIJoC3E+xy93/4Hf/Db27C/0qaDwDUyqkkulu3y7Vb6KrZXQFfxmJpUdCLSeUpyGyL3dfrvO+Z2416C9zBA/8AV1AsCtDGzsgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeIcon);
export default __webpack_public_path__ + "static/media/YouTubeIcon.875b06e2c8f150e654261600abc72453.svg";
export { ForwardRef as ReactComponent };